import React from 'react';
import cx from 'classnames';

import classes from './Table.module.scss';

interface IProps {
  className?: string;
  align?: 'left' | 'center' | 'right';
  children?: React.ReactNode;
}

const HeaderCell: React.FC<IProps> = ({ className, align = 'left', children }) => (
  <th className={cx(classes.headerCell, [`headerCell--${align}`], className)}>{children}</th>
);

export default HeaderCell;
